module.exports = __webpack_public_path__ + "img/emblem_4.00a5a905.svg";